import { Link } from 'react-router-dom';
import type { Patient } from '@/lib/types';
import { ChevronRightIcon } from '@/components/ui/Icons';

interface WorklistRowProps {
  patient: Patient;
  slot?: string;
}

const scoreColor = {
  ok: 'text-ok-deep',
  warn: 'text-warn-deep',
  crit: 'text-crit-deep',
} as const;

export function WorklistRow({ patient: p, slot }: WorklistRowProps) {
  const isAttended = p.appointmentState === 'atendida';

  return (
    <Link
      to={`/patients/${p.id}`}
      className={`grid grid-cols-[64px_1fr_auto_auto_12px] gap-3.5 items-center px-5 py-3 border-b border-line last:border-b-0 transition-colors hover:bg-hover ${isAttended ? 'opacity-60' : ''} max-[760px]:grid-cols-[56px_1fr_auto_12px] max-[760px]:grid-rows-[auto_auto] max-[760px]:gap-x-3 max-[760px]:gap-y-1 max-[760px]:px-4 max-[760px]:py-2.5`}
    >
      <span className="text-[13px] font-semibold tracking-[-0.005em] tnum text-secondary max-[760px]:row-span-2 max-[760px]:self-center">
        {slot ?? '—'}
      </span>
      <div className="min-w-0 max-[760px]:col-start-2 max-[760px]:row-span-2 max-[760px]:self-center">
        <div className="text-sm font-semibold tracking-[-0.005em] mb-px">{p.name}</div>
        <div className="text-xs text-tertiary">
          {p.appointmentType} · {p.age} años · {p.city}
        </div>
      </div>
      <div className="text-right tnum shrink-0 min-w-[32px] max-[760px]:col-start-3 max-[760px]:row-start-1">
        <span className={`text-base font-bold tracking-[-0.02em] leading-none ${p.optimalScore == null ? 'text-muted text-sm font-medium' : scoreColor[p.status]}`}>
          {p.optimalScore}
        </span>
      </div>
      <span
        className={`inline-flex items-center text-[11px] font-semibold tracking-[0.02em] px-2 py-0.5 rounded-sm whitespace-nowrap shrink-0 max-[760px]:col-start-3 max-[760px]:row-start-2 max-[760px]:justify-self-end ${
          isAttended ? 'bg-soft text-tertiary' : 'bg-soft text-secondary'
        }`}
      >
        {isAttended ? 'Atendida' : 'Programado'}
      </span>
      <ChevronRightIcon className="w-3 text-faint shrink-0 max-[760px]:row-span-2 max-[760px]:self-center" />
    </Link>
  );
}
